const PIC_BASE_DIR = '/static/img/recommend/line_special/houen/'
export default {
  pictures: {
    pic1: `${PIC_BASE_DIR}houen_1.png`,
    pic2: `${PIC_BASE_DIR}houen_2.png`,
    pic3: `${PIC_BASE_DIR}houen_3.png`,
  },
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/recommend/lp/counselor/houen/info/lineSpecial.js